import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import {TdoHeaderComponent} from './tdo-header.component';
import { HeaderButtonComponent } from './header-button/header-button.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectivesModule} from '../../directives/directives.module';
import {MainInterfaceModule} from '../main-interface.module';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';

@NgModule({
  declarations: [
    TdoHeaderComponent,
    HeaderButtonComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        MatBadgeModule,
        MatTooltipModule,
        DirectivesModule,
        MainInterfaceModule,
        TdoControlsModule
    ],
  exports: [
    TdoHeaderComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class TdoHeaderModule { }
